import React from "react";

export function StatusPill({ status }) {
  const map = {
    pending: { bg: "bg-amber-100", color: "text-amber-800", label: "Pending" },
    approved: { bg: "bg-emerald-100", color: "text-emerald-800", label: "Approved" },
    rejected: { bg: "bg-rose-100", color: "text-rose-800", label: "Rejected" },
  };
  const s = map[status] || map.pending;
  return (
    <span className={`px-2.5 py-1 rounded-full text-[11px] font-extrabold ${s.bg} ${s.color}`}>
      {s.label}
    </span>
  );
}

export function MetaPill({ Icon, text }) {
  return (
    <span className="inline-flex items-center gap-1 bg-sprouts-bg rounded-md px-2 py-1 text-[11px] font-semibold text-sprouts-text max-w-full">
      <Icon size={11} className="text-sprouts-muted shrink-0" />
      <span className="truncate">{text}</span>
    </span>
  );
}
